export const DEFAULT_COLUMNS = [
  {
    key: "voter_id",
    text: "Voter ID",
    isActive: true,
    canEdit: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "full_name",
    text: "Full Name",
    isActive: true,
    canEdit: true,
    className: "capitalize",
    filter: { type: "search", value: "" },
  },
  {
    key: "status",
    text: "Status",
    isActive: false,
    canEdit: true,
    className: "capitalize",
    filter: {
      type: "search",
      value: "",
    },
  },
  {
    key: "phone_number",
    text: "Phone Number",
    isActive: true,
    canEdit: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "email",
    text: "Email",
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "total_members",
    text: "Network Size",
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "pct_ch_no",
    text: "PCT NO",
    isActive: true,
    canEdit: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "school_district",
    text: "School District",
    canEdit: true,
    isActive: true,
    filter: { type: "dropdown", value: "", values: ["Voted", "Not Voted"] },
  },
  {
    key: "role",
    text: "Role",
    isActive: false,
    canEdit: true,
    className: "capitalize",
    filter: {
      type: "search",
      value: "",
    },
  },
  {
    key: "primary_voting_history",
    text: "Primary Voting History",
    isActive: true,
    filter: { type: "search", value: "" },
  },
  {
    key: "signup_timestamp_central",
    text: "Signup Timestamp",
    isActive: true,
    filter: { type: "dropdown", value: "", values: ["Today", "Yesterday","This Week", "Last 7 Days","Last Week","This Month","Last Month","Last 90 Days","This Year"] },
  },
  {
    key: "multi_column",
    text: "Multi Column",
    isActive: false,
    filter: { type: "dropdown", value: "", values: ["true", "false"] },
  },
  {
    key: "hd",
    text: "HD",
    isActive: false,
    filter: { type: "search", value: "" },
  },
  {
    key: "sd",
    text: "SD",
    isActive: false,
    filter: { type: "search", value: "" },
  },
  {
    key: "precinct",
    text: "Precinct",
    isActive: false,
    filter: { type: "search", value: "" },
  },
  {
    key: "age",
    text: "Age",
    isActive: false,
    filter: { type: "search", value: "" },
  },
  {
    key: "gender",
    text: "Gender",
    isActive: false,
    filter: { type: "search", value: "" },
  },
  {
    key: "street_address",
    text: "Street Address",
    isActive: false,
    className: "capitalize",
    filter: { type: "search", value: "" },
  },
  {
    key: "zipcode",
    text: "Zip Code",
    isActive: false,
    filter: { type: "search", value: "" },
  },

];

export const DEFAULT_SORT = [];
export const DEFAULT_PER_PAGE = 100;

const memory = JSON.parse(localStorage.getItem("admin-memory"));

export default {
  filteredList: [],
  totalPages: 0,
  totalUsers: 0,
  page: 1,
  perPage: memory?.perPage || DEFAULT_PER_PAGE,
  sort: memory?.sort || DEFAULT_SORT,
  columns: memory?.columns || DEFAULT_COLUMNS,
  status: {
    fetchData: "idle",
    editStatus: "idle",
    deleteAccount: "idle",
    deleteData: "idle",
    edit: "idle",
    export: "idle",
    upload: "idle",
  },
};
